exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".domain-tab {\n  border-radius: 0.25rem;\n  padding: 0.75rem;\n  margin-bottom: 1.25rem;\n  border-width: 2px;\n  border-color: transparent;\n  line-height: 1;\n  display: inline-block;\n}\n.domain-tab:hover {\n  border-color: #00ce7d;\n  color: #00ce7d;\n}\n", ""]);

// exports
